import {TextField as MuiTextField} from "@mui/material";

const NumberField = ({config, value, onChange, onEnter, size}) => (
  <MuiTextField
    type="number"
    label={config.label}
    placeholder={config.placeholder ?? "0"}
    size={size}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    onKeyDown={(e) => e.key === "Enter" && onEnter?.()}
    sx={{minWidth: config.width ?? 160}}
  />
);

export default NumberField;
